import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Iterable } from "immutable"

import { EnumDisplayCell, EnumSelectCell } from "app/static/frontend/sheets/components/cells/MantineCells"
import { patchColumnData } from "app/static/frontend/sheets/sheet-action-creators"
import { stanceOptionsConnection } from "shared/stance/selectors"
import { stanceWithCustomLabelByValue } from "shared/stance/helperFunctions"

export interface UnconnectedBillStanceCellProps {
    children?: string | number
    editing?: boolean
    stanceOptions?: any
    immutableStanceOptions?: any[]
}

// a component to render the strings instead of the enums in sheets
export const UnconnectedBillStanceCell = ({ editing, children, ...props }) => {
    // if we are editing, render the select cell
    if (editing) {
        return (
            <EnumSelectCell
                choices={props.immutableStanceOptions}
                item={stanceWithCustomLabelByValue(props.stanceOptions, children)}
                {...props}
            />
        )
        // otherwise, just render the label for the enum
    }
    return (
        <EnumDisplayCell
            choices={props.immutableStanceOptions}
            item={stanceWithCustomLabelByValue(props.stanceOptions, children)}
            {...props}
        />
    )
}

export const BillStanceCell = connect(stanceOptionsConnection, { patchColumnData })(UnconnectedBillStanceCell)
